module.exports = __webpack_public_path__ + "img/clock.cf484e4a.png";